import { type Property } from "@/types/property";
import PropertySidebarItem from "./PropertySidebarItem";
import { Button } from "@/components/ui/button";
import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { Role } from "@/constants/rolePermissions";

interface PropertySidebarProps {
  properties: Property[];
  filteredProperties: Property[];
  rowHeight: number;
  labelColumnWidth: number;
  sidebarScrollRef: React.RefObject<HTMLDivElement>;
  hasScrolledToTodayRef: React.MutableRefObject<boolean>;
  role: Role;
}

const PropertySidebar = ({
  properties,
  filteredProperties,
  rowHeight,
  labelColumnWidth,
  sidebarScrollRef,
  hasScrolledToTodayRef,
  role,
}: PropertySidebarProps) => {

  return (
    <div className="flex flex-col" style={{ width: labelColumnWidth }}>
      <div
        className="border-b border-r bg-white flex items-center justify-between px-4"
        style={{ height: rowHeight }}
      >
        <span className="text-2xl font-bold text-gray-900">
          {properties.length} anuncios
        </span>

        <div className="flex items-center space-x-2">
          <Tooltip delayDuration={200}>
            <TooltipTrigger asChild>
              <Button
                variant="ghost"
                size="icon"
                className="text-brand-primary hover:bg-blue-50"
              >
                <Info className="w-4 h-4" />
              </Button>
            </TooltipTrigger>

            <TooltipContent
              align="end"
              sideOffset={10}
              alignOffset={-10}
              className="text-sm text-muted-foreground max-w-xs text-left px-3 py-2"
            >
              {role === "super_admin" ? (
                <>
                  <p className="text-sm">
                    Tienes permisos especiales para gestionar reservas en cualquier fecha:
                  </p>

                  <ul className="list-disc list-inside mt-1 text-sm">
                    <li>Fechas pasadas</li>
                    <li>Días bloqueados</li>
                    <li>Días disponibles</li>
                  </ul>
                </>
              ) : (
                <>
                  <p className="font-semibold text-xs mb-1 tracking-wide text-gray-600">
                    Solo lectura
                  </p>

                  <p className="text-sm">
                    No puedes crear, editar reservas ni bloquear fechas.
                  </p>
                </>
              )}
            </TooltipContent>
          </Tooltip>
        </div>
      </div>

      <div
        className="border-b border-r bg-white px-2 py-2 space-y-2"
        style={{ height: rowHeight, maxHeight: rowHeight }}
      >
        {/* Espacio reservado - filtros movidos a CalendarFiltersBar */}
      </div>

      <div
        ref={sidebarScrollRef}
        className="flex-1 border-r bg-gray-50/50 overflow-hidden hide-scrollbar"
      >
        {filteredProperties.map((property) => (
          <PropertySidebarItem
            key={property.id}
            id={property.id}
            title={property.title}
            shortName={property.shortName}
            operationStartedAt={property.operationStartedAt}
            imageUrl={property.images[0]}
            available={property.available}
            rowHeight={rowHeight}
            columnWidth={labelColumnWidth}
          />
        ))}
      </div>
    </div>
  );
};

export default PropertySidebar;
